/**
 *
 * NotFound
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { Wrap } from '../../assets/styledAssets/grid';
import { useIntl } from 'react-intl';
import messages from './messages';

interface IProps {}

const NotFound: FunctionComponent<IProps> = () => {
  const intl = useIntl();
  return (
    <Wrap
      alignItems={'center'}
      justifyCont={'center'}
      width={'100%'}
      height={'100%'}
    >
      <h1>{intl.formatMessage(messages.notFound)}</h1>
    </Wrap>
  );
};

export default memo(NotFound);
